import React from 'react';
import {Breadcrumbs, Link, Button, Diary} from 'components';

export function MiddayCheckIn() {
  return (
    <Diary.CheckIn type="midday" next="../mood-meter/">
      <Breadcrumbs>
        <Link to="/diary/">Journal</Link>
        <b>Mid-day Check-in</b>
      </Breadcrumbs>
      <Button className={['primary', 'small', 'pull-right', 'order-100']} to="../mood-meter/" rightIcon="arrow-right">Next</Button>
    </Diary.CheckIn>
  );
}
